// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import { isClient, getBrand, readCookie } from '@tcp/core/src/utils';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import { openPickupModalWithValues } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import {
  fetchRecommendationsDataMonetate,
  fetchRecommendationsDataAdobe,
  sendEventsToMonetate,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import {
  addToCartEcom,
  updateFbtViewStatus,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import {
  getProducts,
  getLoadedProductsCount,
  getFirstSuggestedProduct,
  getRecommendationsAbTest,
  getRecommendationModuleOLabel,
  getRecommendationModulePLabel,
  getABTestConfig,
  getLabelSuffix,
  getMboxName,
  getMonetateEnabledFlag,
  getUpdateFlag,
  getRecommendationLoadingState,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';
import {
  getServerTimeFromState,
  getPromotionsData,
} from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import { getProductDetailFormValues } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors';
import { getCategoryArray } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors';
import {
  getCurrentCurrency,
  getCurrencyAttributes,
} from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getLoadingState,
  getOutfitProducts,
  getAddedToBagErrorCatId,
} from '@tcp/core/src/components/features/browse/OutfitDetails/container/OutfitDetails.selectors';
import {
  getAddedToBagError,
  getAddedToBagFbtError,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';
import BagPageSelector from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import ConfirmationSelector from '@tcp/core/src/components/features/CnC/Confirmation/container/Confirmation.selectors';
import {
  openQuickViewWithValues,
  closeQuickViewModal,
  setPlpDataForQuickView,
  setSlpDataForQuickView,
  setQuickViewProductDetailPageTitle,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { getIsQVOpen } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors.js';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  getUserEmail,
  isPlccUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  getIsDynamicBadgeEnabled,
  getIsDisableDynamicBadgeFlagAbtest,
  getIsPDPSmoothScrollEnabled,
  getIsRedesignedPdpDesktopView,
  getIsCrossBrandMerchandisingEnabled,
  getIsRecommendationProductInformationDisplay,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getisRatingRedesignAbTest,
  getIsRecommendationCarouselRedesignEnabled,
  getCurrentCurrencySymbol,
  getIsBackToQuickviewCTAEnabled,
  getIsPromoMsgEnabledRecommendation,
  getIsTransparentImageSizeReduced,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import RecommendationsView from '../views/Recommendations.view';
import { getCategoryArrayForRecomendation } from '../../../../features/browse/CategoryListingPage/container/CategoryListingPage.selectors';
import {
  RecommendationLabels,
  GLOBAL,
  previousButton,
  nextIconButton,
} from './Recommendations.labels';

// eslint-disable-next-line sonarjs/cognitive-complexity, complexity
export function getRecommendationProducts(state, ownProps, partNumber, reduxKey) {
  let { page } = ownProps;
  if (page === 'home page') page = 'homepage';

  const MONETATE_ENABLED = getMonetateEnabledFlag();
  let products = [];
  if (MONETATE_ENABLED === true)
    products = ownProps.isSuggestedItem
      ? getFirstSuggestedProduct(state, partNumber)
      : getProducts(state, page || 'homepageTest');
  else {
    products = ownProps.isSuggestedItem
      ? getFirstSuggestedProduct(state, partNumber)
      : getProducts(state, reduxKey);
    return products;
  }
  const productsList = [];
  if (!Array.isArray(products)) return products;
  for (let i = 0; i < products.length; i += 1) {
    switch (ownProps.portalValue) {
      case Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED:
        if (products[i].isRecentViewed) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED_UPDATED:
        if (products[i].isRecentViewedUpdated) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.CHECKOUT_SIMILAR_STYLES:
        if (products[i].isPdpPlaProducts) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.OUT_OF_STOCK_PDP:
        if (products[i].isAbPdpOos) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.PLP_PRODUCTS:
        if (products[i].isPlpProducts) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.ADD_PRODUCT_TO_GET_PLACECASH:
        if (products[i].isAbCartCash) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.BAG_CART_REWARD_PLCC:
        if (products[i].isAbCartReward) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.IN_GRID_PLP_PRODUCTS:
        if (products[i].isInGridPlp) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.IN_MULTI_GRID_PLP_PRODUCTS:
        if (products[i].isInMultiGridPlp) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.TRENDING_IN_CATEGORY_PRODUCTS:
        if (products[i].isPlpTrending) productsList.push(products[i]);
        break;
      case Constants.RECOMMENDATIONS_MBOXNAMES.ORDER_PRODUCTS:
        if (products[i].isOrderDetailProduct) productsList.push(products[i]);
        break;
      case 'styleWith':
        if (products[i].styleWithEligibility || products[i].isRecentViewed === false) {
          productsList.push(products[i]);
        }
        break;
      case 'fbt':
        if (products[i].isFbt) {
          productsList.push(products[i]);
        }
        break;
      default:
        if (products[i].isRecentViewed === false) productsList.push(products[i]);
        break;
    }
  }

  return productsList;
}

function getNosearchAvailableProduct(state, ownProps, partNumber, reduxKey) {
  let { page } = ownProps;
  if (page === 'home page') page = 'homepage';
  let products = [];
  products = getProducts(state, page || 'homepageTest' || reduxKey);
  return products;
}

const getReduxKey = (page, newPortalValue) => `${page}_${newPortalValue || 'global'}productsData`;
const getCtaText = (abTestConfig, labelSuffix) =>
  abTestConfig ? `CTA_TEXT_${labelSuffix}` : 'CTA_TEXT';
const getCtaTitle = (abTestConfig, labelSuffix) =>
  abTestConfig ? `CTA_TITLE_${labelSuffix}` : 'CTA_TITLE';
const getCtaUrl = (abTestConfig, labelSuffix) =>
  abTestConfig ? `CTA_URL_${labelSuffix}` : 'CTA_URL';

// eslint-disable-next-line
const mapStateToProps = (state, ownProps) => {
  const {
    page,
    portalValue,
    excludedIds,
    partNumber,
    isOptimisticModalWithError,
    topRecommendationOOS,
    isNoResponseRecommendation,
    isNewPlp = false,
    isRecommendationMarginEnabled,
  } = ownProps;
  const cartItemsCount = readCookie('cartItemsCount');
  const { moduleClassName = '', icidParam = '' } = ownProps;
  const MONETATE_ENABLED = getMonetateEnabledFlag();
  let newPortalValue = portalValue;
  let abTestConfig = null;
  let labelSuffix = `${page}_${ownProps.sequence}`;
  const isSNJSite = getBrand() === 'snj';

  const abTestRecommendations = getRecommendationsAbTest(state, ownProps.isAddedToBag);
  if (abTestRecommendations) {
    abTestConfig = getABTestConfig(abTestRecommendations, ownProps);
    newPortalValue = getMboxName(abTestConfig);
    labelSuffix = getLabelSuffix(page, ownProps, abTestRecommendations);
  }

  const moduleOHeaderLabel = getRecommendationModuleOLabel(
    abTestConfig,
    labelSuffix,
    ownProps,
    isOptimisticModalWithError
  );

  const modulePHeaderLabel = getRecommendationModulePLabel(
    abTestConfig,
    labelSuffix,
    ownProps,
    isOptimisticModalWithError
  );

  const reduxKey = getReduxKey(page, newPortalValue);
  const ctaText = getCtaText(abTestConfig, labelSuffix);
  const ctaTitle = getCtaTitle(abTestConfig, labelSuffix);
  const ctaUrl = getCtaUrl(abTestConfig, labelSuffix);

  const cartItems = [];
  let isBagLoading = false;
  let isOutfitLoading = false;
  let outfitItems = [];

  try {
    if (page === 'cart' || page === 'added_to_bag') {
      isBagLoading = getUpdateFlag(state);
      // Getting cached/api bag order items for recommendation request
      const items = BagPageSelector.getOrderItems(state) || [];
      if (!isBagLoading || items) {
        items.forEach((item) => {
          cartItems.push({
            value: BagPageSelector.getItemPrice(item),
            sku: BagPageSelector.getItemUPC(item),
            pid: BagPageSelector.getItemPartNumber(item),
            quantity: BagPageSelector.getItemQuantity(item),
            currency: getCurrentCurrency(state),
          });
        });
      }
    }

    if (page === 'checkout') {
      const items = ConfirmationSelector.getOrderItems(state);
      if (Array.isArray(items)) {
        items.forEach((item) => {
          if (item) {
            cartItems.push({
              value: item.itemInfo.offerPrice,
              sku: item.productInfo.upc,
              pid: item.productInfo.productPartNumber,
              quantity: item.itemInfo.quantity,
              currency: getCurrentCurrency(state),
            });
          }
        });
      }
    }

    if (page === 'outfit') {
      isOutfitLoading = getLoadingState(state);
      if (!isOutfitLoading) {
        const items = getOutfitProducts(state);
        outfitItems = items.map((item) => ({ productId: item.generalProductId }));
      }
    }
  } catch (e) {
    logger.error({
      error: e,
      extraData: {
        page,
        methodName: Constants.RECOMMENDATIONS_PAGES_MAPPING.RECOMMENDATIONS,
        propsReceived: ownProps,
      },
    });
  }
  const recommLabels = getLabelFromCopyOrFromTranslation(GLOBAL, RecommendationLabels);
  return {
    cartItemsCount,
    categoryName: ownProps.categoryName,
    products: isNoResponseRecommendation
      ? getNosearchAvailableProduct(state, ownProps, partNumber, reduxKey)
      : getRecommendationProducts(state, ownProps, partNumber, reduxKey),
    moduleOHeaderLabel,
    modulePHeaderLabel,
    moduleClassName,
    icidParam,
    ctaText: recommLabels.recommendations?.[ctaText],
    ctaTitle: recommLabels.recommendations?.[ctaTitle],
    ctaUrl: recommLabels.recommendations?.[ctaUrl],
    ariaPrevious: recommLabels.accessibility?.[previousButton],
    ariaNext: recommLabels.accessibility?.[nextIconButton],
    loadedProductCount: getLoadedProductsCount(state),
    currency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    isPlcc: isPlccUser(state),
    reduxKey,
    excludedIds,
    portalValue: newPortalValue,
    showPriceRange: ownProps.showPriceRange,
    cartItems,
    isBagLoading,
    isOutfitLoading,
    outfitItems,
    MONETATE_ENABLED,
    formValues: getProductDetailFormValues(state),
    userEmail: getUserEmail(state),
    addToBagError: getAddedToBagError(state),
    addToBagErrorId: getAddedToBagErrorCatId(state),
    isLoading: getRecommendationLoadingState(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
    isPDPSmoothScrollEnabled: getIsPDPSmoothScrollEnabled(state),
    isSNJEnabled: isSNJSite,
    isConfirmationPage: isClient() && window?.location?.pathname?.indexOf('/confirmation') !== -1,
    isNewPDPEnabled: page === 'pdp' && !topRecommendationOOS,
    addToBagFbtError: getAddedToBagFbtError(state),
    categoryFilterArray: isNewPlp
      ? getCategoryArrayForRecomendation(state)
      : getCategoryArray(state),
    isRedesignedPdpDesktopView: getIsRedesignedPdpDesktopView(state),
    isCrossBrandMerchandisingEnabled: getIsCrossBrandMerchandisingEnabled(state),
    isRecommendationMarginEnabled,
    isRecommendationProductInfoEnabled: getIsRecommendationProductInformationDisplay(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isRatingRedesignAbTest: getisRatingRedesignAbTest(state),
    isRecommendationCarouselRedesignEnabled: getIsRecommendationCarouselRedesignEnabled(state),
    currencySymbol: getCurrentCurrencySymbol(state),
    isQvModalOpen: getIsQVOpen(state),
    isBackToQuickviewCTAEnabled: getIsBackToQuickviewCTAEnabled(state),
    promotionsData: getPromotionsData(state),
    serverTime: getServerTimeFromState(state),
    isPromoMsgEnabledRecommendation: getIsPromoMsgEnabledRecommendation(state),
    isTransparentImageSizeReduceEnabled: getIsTransparentImageSizeReduced(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    loadRecommendationsMonetate: (action) => {
      dispatch(fetchRecommendationsDataMonetate(action));
    },
    loadSendEventsToMonetate: (action) => {
      dispatch(sendEventsToMonetate(action));
    },
    loadRecommendationsAdobe: (action) => {
      dispatch(fetchRecommendationsDataAdobe(action));
    },
    onPickUpOpenClick: (payload) => {
      dispatch(openPickupModalWithValues(payload));
    },
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    addToBagEcomAction: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    updateFbtStatus: (payload) => {
      dispatch(updateFbtViewStatus(payload));
    },
    closeQvModal: () => {
      dispatch(setQuickViewProductDetailPageTitle(''));
      dispatch(closeQuickViewModal({ isModalOpen: false }));
      dispatch(setPlpDataForQuickView(null));
      dispatch(setSlpDataForQuickView(null));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationsView);
